import { connect } from 'react-redux'
import { compose, withProps, withHandlers, lifecycle } from 'recompose'
import withStepperState from 'components/common/hoc/withStepperState'
import { googleAnalyticQuickStepperActionBarClick } from 'actions/googleAnalytic'
import { getAppointmentDatesAndSlots, submitAppointmentContactDetails, sendAppointment } from './actions'
import { setAppointmentConfirmationContactDetails } from 'components/AppointmentConfirmationPage/Checkout/components/AppointmentInfoDrawer/actions'
import { getCompletedSteps, getAppointmentFormValues } from './selectors'
import { storeAppointmentContactDetails } from 'components/AppointmentConfirmationPage/Checkout/helpers'
import StepperContainer from './StepperContainer'

const mapStateToProps = state => {
  const {
    firstName,
    lastName,
    phoneNumber,
    email,
    catalogRefIds: selectedServices
  } = getAppointmentFormValues(state) || {}

  return {
    steps: getCompletedSteps(state),
    appointmentResponse: state.appointment.appointmentResponse,
    contactDetails: { firstName, lastName, phoneNumber, email },
    selectedServices
  }
}

const withStepperProps = withProps(({ cartridges, steps, currentStepIndex }) => {
  const { isDone, cartridgeType, component } = steps[currentStepIndex]
  const hasPrevPage = currentStepIndex > 0
  const hasNextPage = currentStepIndex < steps.length - 1
  const content = cartridges.find(cartridge => cartridge.props.type === cartridgeType)
  return {
    hasPrevPage,
    hasNextPage,
    isDone,
    content,
    Component: component
  }
})

const withDateTimeStepIndex = withProps(() => ({ dateTimeStepIndex: 3 }))

const withLifecycles = lifecycle({
  componentWillUnmount() {
    const { contactDetails, setAppointmentConfirmationContactDetails } = this.props
    storeAppointmentContactDetails({ contactDetails, setAppointmentConfirmationContactDetails })
  }
})

const withNavigationHandlers = withHandlers({
  prevPageClick: ({
    hasPrevPage,
    currentStepIndex,
    setCurrentStepIndex,
    googleAnalyticQuickStepperActionBarClick
  }) => () => {
    if (hasPrevPage) {
      googleAnalyticQuickStepperActionBarClick({ apptStepper: currentStepIndex + 1 })
      setCurrentStepIndex(currentStepIndex - 1)
    }
  },
  nextPageClick: ({
    isDone,
    hasNextPage,
    currentStepIndex,
    setCurrentStepIndex,
    googleAnalyticQuickStepperActionBarClick
  }) => () => {
    if (isDone) {
      if (hasNextPage) {
        googleAnalyticQuickStepperActionBarClick({ apptStepper: currentStepIndex + 1 })
        setCurrentStepIndex(currentStepIndex + 1)
      }
    }
  },
  beforeNavigatingToDateTimeStep: ({
    setAppointmentDetailsResponseVO,
    getAppointmentDatesAndSlots,
    setIsLoading
  }) => () => {
    setIsLoading(true)
    getAppointmentDatesAndSlots({ fiveStepperEnabled: true }).then(({ appointmentDetailsResponseVO }) => {
      setAppointmentDetailsResponseVO(appointmentDetailsResponseVO)
      setIsLoading(false)
    })
  }
})

export default compose(
  connect(mapStateToProps, {
    googleAnalyticQuickStepperActionBarClick,
    setAppointmentConfirmationContactDetails,
    getAppointmentDatesAndSlots,
    submitAppointmentContactDetails,
    sendAppointment
  }),
  withStepperState,
  withLifecycles,
  withDateTimeStepIndex,
  withStepperProps,
  withNavigationHandlers
)(StepperContainer)
